import { dealDamage, addModifier } from '../player.type';
import type { Die } from '../die.type';
import type { Technique } from '../techniques.type';
import type { Player } from '../player.type';
import { StatusEffect } from '../status-effects.type';
import { DieFace } from '../face.type';
import { SoundType } from '../../components/audio.svelte';

export const shell: Technique[] = [
  // Shell Pincer
  {
    ingredients: [DieFace.Shell],
    title: 'Weak Carapace',
    text: 'Gain 1 Barrier.',
    tags: ['defence'],
    audio: SoundType.BuffArmour,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      addModifier(source, StatusEffect.Barrier, 1);
    },
  },
  {
    ingredients: [DieFace.Shell, DieFace.Shell],
    title: 'Carapace',
    text: 'Gain 3 Barrier.',
    tags: ['defence'],
    audio: SoundType.BuffArmour,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      addModifier(source, StatusEffect.Barrier, 3);
    },
  },
  {
    ingredients: [DieFace.Shell, DieFace.Shell, DieFace.Shell],
    title: 'Mega Carapace',
    text: 'Gain 5 Barrier.',
    tags: ['defence'],
    audio: SoundType.BuffArmour,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      addModifier(source, StatusEffect.Barrier, 5);
    },
  },
  {
    ingredients: [DieFace.Shell, DieFace.Bone],
    title: 'Claw Slam2',
    text: 'Deal 2 Damage, Apply 1 Dopey.',
    tags: ['damage', 'debuff'],
    audio: SoundType.AttackBlunt,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      dealDamage({ value: 2, target, source, dice });
      addModifier(target, StatusEffect.Dopey, 1);
    },
  } /* {
    ingredients: [DieFace.Shell, DieFace.Blood],
    title: 'Claw Slam',
    text: 'Deal 2 Damage, Add 1 Dopey',
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      dealDamage({ value: 2, target, source, dice });
      addModifier(target, StatusEffect.Dopey, 1);
    }
  } */,
];
